/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @prettier
 */

import THEME_ACT_ET from '~/styles/themeActEt';

export const baseTheme = THEME_ACT_ET;

export default baseTheme;
